module.exports = __webpack_public_path__ + "img/kbc.8b825c8.svg";